var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.4l-3.7-2.1c-.2-.1-.3 0-.3.2v4.7c0 1.3.7 1.5 1.5.5l2.6-3c.1-.1.1-.3-.1-.3zM22.8 1.8L.9 9.1C-.3 9.5-.4 10.3.7 11l5.8 3.3c.1.1.4.1.5 0l11.6-8.1c.6-.5.7-.4.1.1L9 15.2c-.1.1-.1.3 0 .4l8.5 4.8c.7.4 1.4.1 1.6-.7l4.8-16.9c.3-.8-.2-1.3-1.1-1z"
  })));
}

export default SvgPaperPlane;